import { render, staticRenderFns } from "./TeacherFaculty.vue?vue&type=template&id=2538e9a8"
import script from "./TeacherFaculty.vue?vue&type=script&lang=js"
export * from "./TeacherFaculty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports